const VALUE_END = String.raw`\s"'\\)<>`;
const PARAM_START = '[?&#]|%3F|%26|%23';
const ENCODED_PARAM_END = '%26|%23';

function queryParam(...names: string[]): RegExp {
  const value = `(?:(?!${ENCODED_PARAM_END})[^&#${VALUE_END}])+`;
  return new RegExp(`((?:${PARAM_START})(?:${names.join('|')})(?:=|%3D))${value}`, 'gi');
}

function innerPathSegmentAfter(prefix: string): RegExp {
  return new RegExp(`(${prefix})[^/?#${VALUE_END}]+(?=/)`, 'gi');
}

const CREDENTIALS_IN_URLS = {
  oauthAuthorizationCode: queryParam('code'),
  emailedNavigatorLinkTokens: queryParam('t', 'token'),
  s3PresignedUrlSigningParams: queryParam('x-amz-credential', 'x-amz-security-token', 'x-amz-signature'),
  invitePathToken: innerPathSegmentAfter('/invite/'),
};

function redactCredentials(value: string): string {
  let redacted = value;
  for (const credential of Object.values(CREDENTIALS_IN_URLS)) {
    redacted = redacted.replace(credential, '$1REDACTED');
  }
  return redacted;
}

/** Mutates in place because the SDK's beforeSend hooks keep edits made to the event they receive. */
export function redactUrlCredentials(event: object): void {
  const fields = event as Record<string, unknown>;

  for (const [key, value] of Object.entries(fields)) {
    if (typeof value === 'string') {
      fields[key] = redactCredentials(value);
    } else if (value !== null && typeof value === 'object') {
      redactUrlCredentials(value);
    }
  }
}
